export default {
  computed: {
    setColor() {
      if (!this.color) return ""
      return `color: ${this.color}`
    },
    setBgd() {
      if (!this.color) return ""
      return `background: ${this.color}; border-color: ${this.color}`
    },
    setBorder() {
      if (!this.color) return ""
      return `color: ${this.color}; border-color: ${this.color}`
    },
  }
}